import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import moment from 'moment'
import VueGtag from "vue-gtag";

import { setStore, setAuthToken } from '@/api/session';
import { TOKEN_STORAGE_KEY } from '@/config/runtime';

import 'vuetify/dist/vuetify.min.css'

Vue.config.productionTip = false

// Restore the token synchronously, before Vue mounts. Unguarded routes (e.g.
// /, /news) can fire their first API call from a child component's
// created/mounted, which runs before App.vue's mounted dispatches
// auth/initialize — so we can't rely on the store alone having set it yet.
// Attached to the `session` instance only (see api/session.js::setAuthToken).
const token = localStorage.getItem(TOKEN_STORAGE_KEY)
if (token) {
  setAuthToken(token)
}

setStore(store);

new Vue({
  vuetify,
  router,
  store,
  beforeCreate() {
    this.$store.dispatch('dataTable/loadStateFromStorage');
  },
  moment,
  render: h => h(App)
}).$mount('#app')

// GTAG — enabled whenever a measurement ID is configured.
// Gating on NODE_ENV === 'production' broke custom build modes
// (e.g. `--mode email_only`) because Vue CLI only auto-sets
// NODE_ENV=production for the built-in "production" mode.
// The env var alone is the right switch: set in .env.production,
// .env.test, and .env.email_only; absent in .env.development.
if (process.env.VUE_APP_GTAG_ID) {
  Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_GTAG_ID }
  }, router);
}
